import { render, staticRenderFns } from "./DiscardDefectCultive.vue?vue&type=template&id=ef8c13f2"
import script from "./DiscardDefectCultive.vue?vue&type=script&lang=js"
export * from "./DiscardDefectCultive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports